export default __webpack_public_path__ + "static/media/about_img1.90ed56ca.svg";